import React, { useEffect, useState } from 'react'
import logo from "../../assets/Picture1.png"
import "./NavbarContainer.css"
import { Button, Collapse, Container } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'
import moment from 'moment-hijri'
import { useDispatch, useSelector } from 'react-redux'
import { loginMethod } from '../../hook/auth'
import { addAnswer, clearAnswers } from '../../hook/AnswersCourses'

function NavbarContainer() {
  // State for dynamic time update
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [currentTime, setCurrentTime] = useState('');
  const userinfo = useSelector((state) => state.auth);

  // Function to get the formatted date in Gregorian and Hijri formats
  function getFormattedDate() {
    const today = new Date();

    const gregorian = today.toLocaleDateString("ar-EG", {
      day: "numeric",
      month: "long",
      year: "numeric"
    });

    const hijri = today.toLocaleDateString("ar-SA-u-ca-islamic", {
      day: "numeric",
      month: "long"
    });

    const toEnglishDigits = (str) =>
      str.replace(/[\u0660-\u0669]/g, (d) => d.charCodeAt(0) - 0x0660);

    return `${toEnglishDigits(gregorian)} | ${toEnglishDigits(hijri)}`;
  }

  // Update the current time every second
  useEffect(() => {
    const updateTime = () => {
      const todays = new Date();
      let hours = todays.getHours();
      const minutes = todays.getMinutes().toString().padStart(2, '0'); // Ensure 2 digits
      const seconds = todays.getSeconds().toString().padStart(2, '0'); // Ensure 2 digits

      // Convert 24-hour format to 12-hour format
      const period = hours >= 12 ? 'م' : 'ص';
      hours = hours % 12 || 12; // Convert 0 to 12 for 12AM, and 13 to 1PM, etc.

      const time = `${hours}:${minutes}:${seconds} ${period}`;
      setCurrentTime(time);
    };

    // Update time immediately on load and every second thereafter
    updateTime();
    const intervalId = setInterval(updateTime, 1000);

    // Clear the interval on component unmount to avoid memory leaks
    return () => clearInterval(intervalId);
  }, []); // Empty dependency array means it runs only once, on component mount

  const formatted = getFormattedDate();
  const today = moment();  // Get current date
  const hijriYear = today.iYear();  // Hijri year
  const [open, setOpen] = useState(false);

  return (
    <div
      style={{
        boxShadow: "0px 4px 10px rgba(0,0,0,0.1)"
      }}
    >
      <Container>
        <div className='d-flex justify-content-between align-items-center navbar_container'>
          <div className='img_container'>
            <Link to={"/"}>
              <img src={logo} alt='' className='w-100' />

            </Link>
          </div>
          <div>
            <p className='mb-0 text-right time_container'>
              {currentTime} | {formatted}  {hijriYear} هـ
            </p>
          </div>
          <div>
            <div
              onClick={() => setOpen(!open)}
              aria-controls="example-collapse-text"
              aria-expanded={open}
              className='example-collapse-text'
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" class="bi bi-list" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5" />
              </svg>
            </div>

            {userinfo.access_token ?
            <div className='left_container_lg'>
              <div className='d-flex align-items-center '>
                <p className='mb-0 name_lg'>
                  {userinfo?.userArray?.username} اهلا  ,

                </p>
                <p className='bg_main mt-4 rounded text-white  py-2 mx-3 text-center'
                  style={{ width: "120px", }}
                  onClick={() => {

                    dispatch(loginMethod({
                      data: {},
                      access_token: ""
                    }))
        dispatch(clearAnswers())
                    navigate("/")
                  }}>تسجيل الخروج</p>
              </div>
              </div>
              // <p className='bg_main mt-4 rounded text-white px-4 py-1'>{userinfo?.userArray?.username} اهلا ,</p>
              :
              <Link className='bg_main mt-4 rounded text-white px-4 py-1 left_container_lg' to="/">تسجيل الدخول</Link>

            }
          </div>
        </div>

      </Container>
        <Collapse className='mb-4 pb-2' in={open}style={{
  boxShadow: "0 10px 10px rgba(0, 0, 0, 0.15)",
  borderBottomRightRadius: "25px",
  borderBottomLeftRadius: "25px",

}}
>
          <Container>
            <div id="example-collapse-text ">
              <div className='d-flex justify-content-between align-items-center'>
                <p className='mb-0 '>
                  {userinfo?.userArray?.username} اهلا  ,

                </p>
                {userinfo.access_token ?
                  <div className='d-flex align-items-center'>
                    <p className='mb-0 name_lg'>
                      {userinfo?.userArray?.username} اهلا  ,

                    </p>
                    <p className='bg_main mt-4 rounded text-white  py-2 mx-3 text-center'
                      style={{ width: "120px", }}
                      onClick={() => {

                        dispatch(loginMethod({
                          data: {},
                          access_token: ""
                        }))
                        navigate("/")
                      }}>تسجيل الخروج</p>
                  </div>
                  // <p className='bg_main mt-4 rounded text-white px-4 py-1'>{userinfo?.userArray?.username} اهلا ,</p>
                  :
                  <Link className='bg_main mt-4 rounded text-white px-4 py-1' to="/">تسجيل الدخول</Link>

                }

              </div>


            </div>
          </Container>
        </Collapse>
      <Container className='pb-4'>

        <p className='mb-0 text-right time_container_med '>
          {currentTime} | {formatted}  {hijriYear} هـ
        </p>

      </Container>
    </div>
  );
}

export default NavbarContainer;
